<mat-card *ngIf="device" class="device-card" (click)="!iconHovered && openDetails($event, deviceType)" matRipple
  [matRippleDisabled]="iconHovered"
  [ngClass]="['border-color-' + Keys[deviceType], 'hover-color-' + Keys[deviceType], iconHovered ? '' : 'body-hover']">
  <div class="device-card-main-container">
    <mat-card-header class="device-card-header">
      <mat-card-title class="device-card-title">{{device.externalDeviceId}}
        <mat-icon class="title-copy-icon" (click)="copyClick($event, extTooltip)" #extTooltip="matTooltip"
          (mouseenter)="copyHover($event)" (mouseleave)="copyHoverEnd($event, extTooltip)"
          [cdkCopyToClipboard]="device.externalDeviceId" [matTooltip]="'devices.table.copied' | translate"
          matTooltipPosition="right" matTooltipClass="copy-tooltip">content_copy</mat-icon>
      </mat-card-title>
      <mat-card-subtitle class="device-card-subtitle">
        <p class="subtitle-value">
          {{Types[deviceType].translateString | translate}}</p>
      </mat-card-subtitle>
      <!-- <div class="device-header-indicator-list">
        <div *ngIf="device.operationStatus" class="device-header-status-indicator" (mouseover)="iconHovered = true"
          (mouseleave)="iconHovered = false" [matTooltip]="'devices.status.' + status | translate"
          matTooltipPosition="left" [matTooltipShowDelay]="1000" [ngClass]="'status-' + status"
          [matTooltipClass]="'status-tooltip-' + status" matRipple
          (click)="openDetails($event, deviceType, Mode.MONITORING)">
          <span class="material-icons-outlined status-icon">
            {{ statusData?.icon }}
          </span>
        </div>
      </div> -->
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="device-card-content">
      <div class="card-items" *ngIf="!editMode" [@appear]>
        <div class="card-item">
          <div class="item-title">{{'devices.table.header.device-id' | translate}}</div>
          <div class="item-value" [ngClass]="'item-value-' + Keys[deviceType]">{{device.deviceId}}
          </div>
          <mat-icon class="copy-icon" (click)="copyClick($event, tooltip)" #tooltip="matTooltip"
            (mouseenter)="copyHover($event)" (mouseleave)="copyHoverEnd($event, tooltip)"
            [cdkCopyToClipboard]="device.deviceId.toString()" [matTooltip]="'devices.table.copied' | translate"
            matTooltipPosition="above" matTooltipClass="copy-tooltip"
            [matTooltipHideDelay]="500">content_copy</mat-icon>
        </div>
        <div class="card-item" *ngIf="multiCustomer">
          <div class="item-title">{{'devices.table.header.customer-name' | translate}}</div>
          <div class="item-value" [ngClass]="'item-value-' + Keys[deviceType]">
            {{device.customerName}}</div>
          <mat-icon class="copy-icon" (click)="copyClick($event, tooltip)" #tooltip="matTooltip"
            (mouseenter)="copyHover($event)" (mouseleave)="copyHoverEnd($event, tooltip)"
            [cdkCopyToClipboard]="device.customerName" [matTooltip]="'devices.table.copied' | translate"
            matTooltipPosition="right" matTooltipClass="copy-tooltip"
            [matTooltipHideDelay]="500">content_copy</mat-icon>
        </div>
        <div class="card-item" *ngIf="device.gateFactorySn">
          <div class="item-title">{{'devices.table.header.factory-sn' | translate}}</div>
          <div class="item-value" [ngClass]="'item-value-' + Keys[deviceType]">{{device.gateFactorySn}}
          </div>
          <mat-icon class="copy-icon" (click)="copyClick($event, tooltip)" #tooltip="matTooltip"
            (mouseenter)="copyHover($event)" (mouseleave)="copyHoverEnd($event, tooltip)"
            [cdkCopyToClipboard]="device.gateFactorySn" [matTooltip]="'devices.table.copied' | translate"
            matTooltipPosition="right" matTooltipClass="copy-tooltip"
            [matTooltipHideDelay]="500">content_copy</mat-icon>
        </div>
        <div class="card-item" *ngIf="device.logisticStatus || canEdit">
          <div class="item-title">{{'devices.table.header.logistic-status' | translate}}</div>
          <div class="item-value" [ngClass]="'item-value-' + Keys[deviceType]" *ngIf="device.logisticStatus">
            {{device.logisticStatus}}
          </div>
          <div *ngIf="canEdit" class="logistic-edit-button" (mouseover)="iconHovered = true"
            (mouseleave)="iconHovered = false" [matTooltip]="'devices.table.edit' | translate"
            matTooltipPosition="right" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]"
            [ngClass]="['logistic-edit-button-' + Keys[deviceType]]" matRipple (click)="openEdit($event, 'logInput')">
            <mat-icon class="edit-icon material-icons-outlined">edit</mat-icon>
          </div>
          <mat-icon class="copy-icon" *ngIf="device.logisticStatus" (click)="copyClick($event, tooltip)"
            #tooltip="matTooltip" (mouseenter)="copyHover($event)" (mouseleave)="copyHoverEnd($event, tooltip)"
            [cdkCopyToClipboard]="device.logisticStatus" [matTooltip]="'devices.table.copied' | translate"
            matTooltipPosition="right" matTooltipClass="copy-tooltip"
            [matTooltipHideDelay]="500">content_copy</mat-icon>
        </div>
        <div class="card-item" *ngIf="device.logisticStatusDesc || canEdit">
          <div class="item-title">{{'devices.table.header.logistic-status-desc' | translate}}</div>
          <div class="item-value logistic-desc-value" [ngClass]="'item-value-' + Keys[deviceType]"
            *ngIf="device.logisticStatusDesc">
            {{device.logisticStatusDesc}}
          </div>
          <div *ngIf="canEdit" class="logistic-edit-button" (mouseover)="iconHovered = true"
            (mouseleave)="iconHovered = false" [matTooltip]="'devices.table.edit' | translate"
            matTooltipPosition="right" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]"
            [ngClass]="['logistic-edit-button-' + Keys[deviceType]]" matRipple (click)="openEdit($event, 'logDescArea')">
            <mat-icon class="edit-icon material-icons-outlined">edit</mat-icon>
          </div>
          <mat-icon class="copy-icon" *ngIf="device.logisticStatusDesc" (click)="copyClick($event, tooltip)"
            #tooltip="matTooltip" (mouseenter)="copyHover($event)" (mouseleave)="copyHoverEnd($event, tooltip)"
            [cdkCopyToClipboard]="device.logisticStatusDesc" [matTooltip]="'devices.table.copied' | translate"
            matTooltipPosition="right" matTooltipClass="copy-tooltip"
            [matTooltipHideDelay]="500">content_copy</mat-icon>
        </div>
      </div>
      <div class="card-edit-form" [formGroup]="editForm" *ngIf="editMode" (mouseover)="iconHovered = true"
        (mouseleave)="iconHovered = false" [@appear]>
        <mat-form-field appearance="outline" class="card-edit-form-field">
          <mat-label>{{'devices.detail.basic.logistic-status' | translate}}</mat-label>
          <input #logInput type="text" matInput formControlName="logisticStatus" [matAutocomplete]="logAuto" maxlength="20">
          <mat-autocomplete autoActiveFirstOption #logAuto="matAutocomplete" class="card-edit-autocomplete">
            <mat-option *ngFor="let logValue of logValuesObservable | async" [value]="logValue">
              {{logValue}}
            </mat-option>
          </mat-autocomplete>
          <button [ngStyle]="{'visibility': emptyFilter('logisticStatus') ? 'hidden' : 'visible'}" matSuffix
            mat-icon-button aria-label="Clear" (click)="clearFilter('logisticStatus', $event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" class="card-edit-form-field">
          <mat-label>{{'devices.detail.basic.logistic-status-desc' | translate}}</mat-label>
          <textarea matInput formControlName="logisticStatusDesc" cdkTextareaAutosize #logDescArea="cdkTextareaAutosize"
            maxlength="256"></textarea>
          <button [ngStyle]="{'visibility': emptyFilter('logisticStatusDesc') ? 'hidden' : 'visible'}" matSuffix
            mat-icon-button aria-label="Clear" (click)="clearFilter('logisticStatusDesc', $event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div class="card-logistic-edit-buttons">
          <button mat-stroked-button color="transparent" class="card-logistic-edit-button" (click)="closeEdit($event)">
            <mat-icon>cancel</mat-icon>{{ 'button.cancel' | translate}}
          </button>
          <button mat-stroked-button color="transparent" class="card-logistic-edit-button"
            (click)="closeEdit($event, true)">
            <mat-icon>save</mat-icon>{{ 'button.save' | translate}}
          </button>
        </div>
      </div>
    </mat-card-content>
  </div>
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="50">
    </mat-progress-spinner>
  </div>
  <mat-card-actions class="device-card-actions">
    <button class="button-flex-6 device-link" mat-stroked-button (mouseover)="iconHovered = true"
      (mouseleave)="iconHovered = false" (click)="openDetails($event, Keys.GATE)"
      *ngIf="device.gateExtDeviceId && deviceType !== Keys.GATE" [matTooltip]="device.gateExtDeviceId"
      [matTooltipShowDelay]="1000" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]">
      <mat-icon [type]="Keys.GATE"></mat-icon>
    </button>
    <button class="button-flex-6 device-link" mat-stroked-button (mouseover)="iconHovered = true"
      (mouseleave)="iconHovered = false" (click)="openDetails($event, Keys.SZT)"
      *ngIf="device.sztExtDeviceId && deviceType !== Keys.SZT" [matTooltip]="device.sztExtDeviceId"
      [matTooltipShowDelay]="1000" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]">
      <mat-icon [type]="Keys.SZT"></mat-icon>
    </button>
    <button class="button-flex-6 device-link" mat-stroked-button (mouseover)="iconHovered = true"
      (mouseleave)="iconHovered = false" (click)="openDetails($event, Keys.SIMCARD)"
      *ngIf="device.simExtDeviceId && deviceType !== Keys.SIMCARD" [matTooltip]="device.simExtDeviceId"
      [matTooltipShowDelay]="1000" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]">
      <mat-icon [type]="Keys.SIMCARD"></mat-icon>
    </button>
    <!-- <button class="button-flex-1 device-link" *ngIf="deviceType === Keys.GATE" mat-stroked-button
      (click)="openDetails($event, Keys.GATE, Mode.PLOTS)" (mouseover)="iconHovered = true"
      (mouseleave)="iconHovered = false" [matTooltip]="'devices.table.header.plots' | translate"
      [matTooltipShowDelay]="1000" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]">
      <mat-icon fontIcon="bar_chart"></mat-icon>
    </button> -->
  <button class="button-flex-1 device-link datasheet" mat-flat-button (mouseover)="iconHovered = true"
            (mouseleave)="iconHovered = false" (click)="!isDownloading && downloadDatasheet($event)"
            [class.disabled]="isDownloading"
            *ngIf="device.gateExtDeviceId && deviceType === Keys.SZT" [matTooltip]="'devices.table.header.download' | translate"
            [matTooltipShowDelay]="1000" [matTooltipClass]="['edit-tooltip-' + Keys[deviceType]]">
      <mat-icon>download</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
